import { render, staticRenderFns } from "./langChange.vue?vue&type=template&id=1b345f1b&"
import script from "./langChange.vue?vue&type=script&lang=js&"
export * from "./langChange.vue?vue&type=script&lang=js&"
import style0 from "./langChange.vue?vue&type=style&index=0&id=1b345f1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports